export default function TrackEvent (event) {
    var getTrackerName = function () {
        if (window.ga) {
            const trackers = window.ga.getAll();
            const firstTracker = trackers[0];
            return firstTracker.get('name');
        }
        return false;
    }

    if (window.ga) {
        var tracker = getTrackerName();
        if (tracker) {
            ga(tracker + '.send', event);
        }
    }
}